import React from 'react'
import { Percent, Decimal1Digit } from '../../Utils/formatting/formatting'
import type { TeamStats } from '../../Api'
import { StatCon, StatsTableCon } from './styles'

type TeamStatsTableProps = { stats: TeamStats }

export const TeamStatsTable: React.FC<React.PropsWithChildren<TeamStatsTableProps>> = ({
  stats,
}) => {
  return (
    <StatsTableCon>
      {!stats ? (
        <div> No team stats for this season </div>
      ) : (
        <>
          <StatCon>
            <div className="stat">{stats.gamesPlayed}</div>
            <p className="statText">Games</p>
          </StatCon>
          {stats?.scoresPG && (
            <StatCon>
              <div className="stat">{Decimal1Digit(stats.scoresPG)}</div>
              <p className="statText">Scores Per Gm</p>
            </StatCon>
          )}
          {stats?.saa && (
            <StatCon>
              <div className="stat">{Decimal1Digit(stats.saa)}</div>
              <p className="statText">Scores Against Avg</p>
            </StatCon>
          )}
          <StatCon>
            <div className="stat">{stats.scores}</div>
            <p className="statText">Scores</p>
          </StatCon>
          <StatCon>
            <div className="stat">{stats.scoresAgainst}</div>
            <p className="statText">Scores Against</p>
          </StatCon>
          <StatCon>
            <div className="stat">{stats.groundBalls}</div>
            <p className="statText">Groundballs</p>
          </StatCon>
          <StatCon>
            <div className="stat">{Percent(stats.shotPct)}</div>
            <p className="statText">Shot %</p>
          </StatCon>
          <StatCon>
            <div className="stat">{Percent(stats.faceoffPct)}</div>
            <p className="statText">Faceoff %</p>
          </StatCon>
          <StatCon>
            <div className="stat">{Percent(stats.savePct)}</div>
            <p className="statText">Save %</p>
          </StatCon>
        </>
      )}
    </StatsTableCon>
  )
}
